<template>
  <div class="row">
    <div
      class="col-lg-4 col-md-6 col-12"
      v-for="product in products"
      :key="product.id"
    >
      <!-- Start Single Item -->
      <div class="single-item-grid">
        <div class="image">
          <a @click.prevent="seeProduct(product.id)" href=""
            ><img :src="product.imgUrl" alt="Product Image"
          /></a>

        </div>
        <div class="content">
          <a @click.prevent="seeProduct(product.id)" href="" class="tag">{{
            product.Category.name
          }}</a>
          <h3 class="title">
            <a @click.prevent="seeProduct(product.id)" href="">{{ product.name }}</a>
          </h3>
          <p class="location ">
            <a @click.prevent="seeProduct(product.id)" href=""
              class="d-inline-block text-truncate" style="max-width: 150px;">{{ product.description }}</a
            >
          </p>
          <ul class="info">
            <li class="price">{{product.price }}</li>
          </ul>
        </div>
      </div>
      <!-- End Single Item -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  methods: {
    seeProduct(productId) {
      this.$router.push(`products/${productId}`).catch(()=>{})
      
    },
    // removeFavorite(payload) {
    //   this.$store.dispatch();
    // },
  },
  computed: {
    products() {
      let formattedProducts = this.$store.state.products;
      formattedProducts.map(product=> {
         product.price = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      }).format(product.price);
      })
      return formattedProducts
    },
  },
};
</script>

